import React from 'react';
import { cnTextinput } from '../Textinput';
import './Textinput-Hint.css';
export var TextinputHint = function (_a) {
    var leave = _a.leave, onAnimationEnd = _a.onAnimationEnd, children = _a.children;
    return (React.createElement("span", { className: cnTextinput('Hint', { leave: leave }), onAnimationEnd: onAnimationEnd }, children));
};
